module.exports = __webpack_public_path__ + "static/media/debit_international.9eb13633.svg";